import axios from 'axios';

import { JsonResponse } from 'core/models/response';
import {
	CalculateTotalAmountResponse,
	CreateDividendPayload,
	DividendPreviewResponse,
	DividendResponse,
	DividendsListResponse,
	DividendsOtpKey,
	SearchDividendShareholderResponse,
} from '../models/dividends';

export const onGetDividendsList = async (page: number = 1) => {
	try {
		const response = await axios.get<JsonResponse<DividendsListResponse>>('dashboard/actions/dividends', {
			params: { page },
		});
		return response.data.data;
	} catch (error) {
		throw error;
	}
};

export const onGetDividendById = async (id: string) => {
	try {
		const response = await axios.get<JsonResponse<DividendResponse>>(`dashboard/actions/dividends/${id}`);
		return response.data.data;
	} catch (error) {
		throw error;
	}
};

export const onCancelDividend = async (id: number, otp: string) => {
	try {
		const response = await axios.put(`dashboard/actions/dividends/${id}/cancel`, { otp });
		return response.data.data;
	} catch (error) {
		throw error;
	}
};

export const onCheckEligibilityDate = async (eligibility_date: string) => {
	try {
		const response = await axios.post<JsonResponse<{ isValidEligibilityDate: boolean }>>('dashboard/actions/dividends/check-eligibility-date', {
			eligibility_date,
		});
		return response.data.data;
	} catch (error) {
		throw error;
	}
};

export const onCalculateTotalAmount = async (
	eligibility_date: string,
	revenue_per_share: string,
	forbidden_excepted_shareholders: number[],
	direct_transfer_excepted_shareholders: number[],
) => {
	try {
		const response = await axios.post<JsonResponse<CalculateTotalAmountResponse>>('dashboard/actions/dividends/calculate-total-amount', {
			eligibility_date,
			revenue_per_share,
			forbidden_excepted_shareholders,
			direct_transfer_excepted_shareholders,
		});
		return response.data.data;
	} catch (error) {
		throw error;
	}
};

export const onSendDividendOtp = async (type: DividendsOtpKey) => {
	try {
		const response = await axios.post<JsonResponse<{ ttl: number }>>('dashboard/actions/dividends/send-otp', { type });
		return response.data.data;
	} catch (error) {
		throw error;
	}
};

export const onCreateDividend = async (payload: CreateDividendPayload) => {
	try {
		const response = await axios.post('dashboard/actions/dividends/create', payload);
		return response.data.data;
	} catch (error) {
		throw error;
	}
};

export const onUpdateDividend = async (id: string, payload: CreateDividendPayload) => {
	try {
		const response = await axios.put(`dashboard/actions/dividends/update/${id}`, payload);
		return response.data.data;
	} catch (error) {
		throw error;
	}
};

export const onSearchDividendShareholder = async (eligibility_date: string, revenue_per_share: string, keyword: string) => {
	try {
		const response = await axios.post<JsonResponse<SearchDividendShareholderResponse>>('dashboard/actions/dividends/search-shareholders', {
			eligibility_date,
			revenue_per_share,
			keyword,
		});
		return response.data.data;
	} catch (error) {
		throw error;
	}
};

export const onUpdateDividendShareholderIban = async (eligibility_date: string, shareholder_id: string, iban: string) => {
	try {
		const response = await axios.post<JsonResponse<SearchDividendShareholderResponse>>('dashboard/actions/dividends/update-shareholder-iban', {
			eligibility_date,
			shareholder_id,
			iban,
		});
		return response.data.data;
	} catch (error) {
		throw error;
	}
};

export const onPreviewDividend = async (id: string, page: number) => {
	try {
		const response = await axios.get<JsonResponse<DividendPreviewResponse>>(`dashboard/actions/dividends/${id}/preview`, {
			params: { page },
		});
		return response.data.data;
	} catch (error) {
		throw error;
	}
};
